import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ReportUserGroupPermission } from '../../_types/report-user-group-permission';
import { ReportsUsersGroupsPermissionsService } from '../../_services/reports-users-groups-permissions.service';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { GroupsService } from 'src/app/modules/groups/_services/groups.service';
import { LoginService } from 'src/app/modules/login/login.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';

@Component({
    selector: 'app-reports-users-groups-permissions',
    templateUrl: './reports-users-groups-permissions.component.html',
    styleUrls: ['./reports-users-groups-permissions.component.scss'],
    standalone: false
})
export class ReportsUsersGroupsPermissionsComponent {
  public reportUserGroupPermissionFormGroup!: RxFormGroup

  public reportUserGroupPermission: ReportUserGroupPermission = new ReportUserGroupPermission();
  public usersGroups: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public type: string = '';


  constructor(
    private reportsUsersGroupsPermissionsService: ReportsUsersGroupsPermissionsService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private usersService: UsersService,
    private groupsService: GroupsService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {
    this.reportUserGroupPermissionFormGroup = this.formBuilder.formGroup<ReportUserGroupPermission>(this.reportUserGroupPermission) as RxFormGroup;
  }

  async ngOnInit(): Promise<void> {
    this.usersGroups = [];
    this.type = this.config.data.type;

    if (this.config.data.reportUserGroupPermissionId) {
      await this.loadReportUserGroupPermission(this.config.data.reportUserGroupPermissionId);      
    } else {
      this.reportUserGroupPermission.reportId = this.config.data.reportId;      
    }
    if(this.config.data.type == 'USER') {
      this.loadUsers();
    } else {
      this.loadGroups();
    }    
    this.allowWrite = this.loginService.hasPermission("REPORTS.WRITE");
    this.allowDelete = this.loginService.hasPermission("REPORTS.DELETE");
  }

  async loadReportUserGroupPermission(id: string) {
    
    this.reportUserGroupPermission = await firstValueFrom(this.reportsUsersGroupsPermissionsService.get(id));
    this.reportUserGroupPermissionFormGroup.patchValue(this.reportUserGroupPermission);
    

  }
   async loadUsers(event?: any) {
       let text = "";
      if (event != null) text = event.filter; 
      let filters: any = {
        name: new Filter(FilterOperation.contains, 'name', '', text)      
      };
      if(this.reportUserGroupPermission && this.reportUserGroupPermission.userId){
        filters['name'] = new OrFilter([
           new Filter(FilterOperation.contains, 'name', '', text),
          new Filter(FilterOperation.equals, 'id', '', this.reportUserGroupPermission.userId)
      ]);
      }
      let params: IParamsCollection = {
        page: { size: 100, number: 1 },
        sort: ['name'],
        filter: FilterBuilder.fromObject(filters).build()
      };

    let response = await firstValueFrom(this.usersService.all(params));
    this.usersGroups = response.data;
  }

  async loadGroups() {
    let response = await firstValueFrom(this.groupsService.all());
    this.usersGroups = response.data;
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.reportUserGroupPermissionFormGroup);
    if (valid) {
      this.reportUserGroupPermission = Object.assign(this.reportUserGroupPermission, this.reportUserGroupPermissionFormGroup.value);            
      await this.reportsUsersGroupsPermissionsService.save(this.reportUserGroupPermission).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Permiso guardado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar permiso' });
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Existen errores, por favor revise el formulario de datos.' });
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar los permisos?",
      header: "Eliminar permisos",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.reportsUsersGroupsPermissionsService.delete(this.reportUserGroupPermission.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Permiso eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
